import { Button, Modal } from "react-bootstrap";
import useKeypress from "react-use-keypress";

const ChangeAmountModal = ({ show, handleClose, amount }) => {
  // Support Esc key to close the modal
  useKeypress("Escape", () => {
    if (show) {
      handleClose();
    }
  });

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Body className="text-center p-5">
        <h2 className="mb-4 text-secondary">Change Amount</h2>
        <h1 className="display-1 fw-bold text-success mb-4">
          {parseFloat(amount).toFixed(2)}
        </h1>
        <p className="text-muted mb-4">
          Press <span className="badge bg-dark">Esc</span> or click the button below to close
        </p>
        <Button 
          variant="dark" 
          size="lg" 
          className="px-5 py-2 rounded-pill" 
          onClick={handleClose}
        >
          Close
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ChangeAmountModal;
